import {
  DEV_STRIPE_PUBLIC_KEY,
  GV_API_AUTH_CLIENT_ID,
  GV_API_AUTH_CLIENT_SECRET,
  PRODUCTION_GV_API_AUTH_CLIENT_ID,
  PRODUCTION_GV_API_AUTH_CLIENT_SECRET,
  PROD_STRIPE_PUBLIC_KEY,
} from "./gvSecrets";

const LOCAL_URL_PREFIX = "http://localhost:8000";
const URL_PREFIX = "https://api.growthvectors.io";

/** True if running on localhost */
export const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === "[::1]" ||
  // 127.0.0.1/8 is considered localhost for IPv4.
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),
);

/** True if running on a PR preview domain (*.previews.growthvectors.io) */
const isPreview = window.location.hostname.includes(".previews.");

/** True if running in production (not localhost and not preview) */
export const isProduction = !isLocalhost && !isPreview;

/** Returns the environment name for services like Sentry */
export function getEnvironment(): "development" | "preview" | "production" {
  if (isLocalhost) return "development";
  if (isPreview) return "preview";
  return "production";
}

export function getURLPrefix() {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  if (isLocalhost) {
    return LOCAL_URL_PREFIX;
  }
  return URL_PREFIX;
}

export function getAPIKeys() {
  if (isLocalhost) {
    return {
      API_AUTH_CLIENT_ID: GV_API_AUTH_CLIENT_ID,
      API_AUTH_SECRET: GV_API_AUTH_CLIENT_SECRET,
    };
  }
  return {
    API_AUTH_CLIENT_ID: PRODUCTION_GV_API_AUTH_CLIENT_ID,
    API_AUTH_SECRET: PRODUCTION_GV_API_AUTH_CLIENT_SECRET,
  };
}

export function getStripePublicKey() {
  if (isLocalhost) {
    return DEV_STRIPE_PUBLIC_KEY;
  }
  return PROD_STRIPE_PUBLIC_KEY;
}
